export const ITEMS_PER_PAGE = 60;

export const DEFAULT_VISIBLE_PAGES = 7;

export const SORT_OPTIONS = [
  { value: 'name-asc', label: 'A → Z' },
  { value: 'name-desc', label: 'Z → A' },
  { value: 'recent', label: 'Recent' },
] as const;
